var exports = {
  "Kk": "VoiceSettingsMenus.module__icon___UU9DZF",
  "XK": "VoiceSettingsMenus.module__leadingActionLabel___UU9DZF",
  "CS": "VoiceSettingsMenus.module__inputLevelItem___UU9DZF",
  "lL": "VoiceSettingsMenus.module__inputLevelLabel___UU9DZF",
  "_A": "VoiceSettingsMenus.module__inputLevelMeter___UU9DZF",
};

module.exports = exports;
